import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITimelineStateProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import Button from "../../../button";
import Icon from "../../../icon";
import Text from "../../../text";

const TimelineState: FC<ITimelineStateProps> = ({
    onActionPress,
    actionTitle,
    customTheme,
    description,
    icon,
    title
}) => {
    const {
        controlHeights,
        shapeConfigs,
        iconSizes,
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle,
        iconBox: iconBoxDynamicStyle,
        action: actionDynamicStyle
    } = useStyles({
        controlHeights,
        shapeConfigs,
        radiuses,
        colors,
        spaces
    });

    return <View
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        <View
            style={[
                stylesheet.iconBox,
                iconBoxDynamicStyle
            ]}
            aria-hidden={true}
        >
            <Icon
                customTheme={customTheme}
                size={iconSizes.large}
                icon={icon}
                color="mid"
            />
        </View>
        <Text
            variant="titleMediumSize"
            customTheme={customTheme}
            style={stylesheet.text}
            role="heading"
            color="high"
        >
            {title}
        </Text>
        {
            description ?
                <Text
                    customTheme={customTheme}
                    variant="bodyMediumSize"
                    style={stylesheet.text}
                    color="mid"
                >
                    {description}
                </Text>
            :
                null
        }
        {
            actionTitle && onActionPress ?
                <View
                    style={actionDynamicStyle}
                >
                    <Button
                        customTheme={customTheme}
                        onPress={onActionPress}
                        title={actionTitle}
                        variant="outline"
                        type="neutral"
                    />
                </View>
            :
                null
        }
    </View>;
};
export default TimelineState;
